
import Vue from 'vue'

export default Vue.extend({
  name: 'ErrorBoundary',
  data: () => ({
    error: false,
    message: 'Something went wrong',
  }),
  errorCaptured(err, vm, info) {
    this.error = true
  },
  render(createElement) {
    return createElement('div',
      this.error ? this.message : this.$slots.default
    )
  },
})
